module.exports = __webpack_public_path__ + "img/banner_hk.436f3e58.jpg";